import { render, staticRenderFns } from "./teacher-students-note.vue.js?vue&type=template&id=d6d5a536&scoped=true!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./teacher-students-note.vue?vue&type=template&id=d6d5a536&scoped=true"
import script from "./teacher-students-note.vue.js?vue&type=script&setup=true&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./teacher-students-note.vue?vue&type=script&setup=true&lang=js"
export * from "./teacher-students-note.vue.js?vue&type=script&setup=true&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./teacher-students-note.vue?vue&type=script&setup=true&lang=js"
import style0 from "./teacher-students-note.vue.css?vue&type=style&index=0&id=d6d5a536&prod&scoped=true&lang=css!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./teacher-students-note.vue?vue&type=style&index=0&id=d6d5a536&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d5a536",
  null
  
)

export default component.exports